import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'gtw-not-found',
    template: `
    <div class="error-page">
      <div class="error-page__icon">
        <i class="fa fa-exclamation-triangle"></i>
      </div>
      <h1 class="error-page__code">404</h1>
      <p class="error-page__message">Page Not Found</p>
      <p class="error-page__hint">The page you are looking for does not exist or has been moved.</p>
      <a routerLink="/home" class="error-page__link">Go to Home</a>
    </div>
  `,
    styles: [`
    .error-page {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      min-height: 60vh;
      text-align: center;
      padding: 40px;
    }
    .error-page__icon { font-size: 64px; color: #dc3545; margin-bottom: 16px; }
    .error-page__code { font-size: 72px; font-weight: 700; margin: 0; color: #333; }
    .error-page__message { font-size: 24px; color: #555; margin: 8px 0; }
    .error-page__hint { font-size: 14px; color: #888; margin-bottom: 24px; }
    .error-page__link {
      padding: 10px 24px;
      background: #0056b3;
      color: #fff;
      text-decoration: none;
      border-radius: 4px;
    }
    .error-page__link:hover { background: #004094; }
  `],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class NotFoundComponent {}
